<template>
  <div class="wrapper">
    <p class="title">{{ $t("common.permissions") }}</p>
    <div class="content">
      <!-- header  -->

      <VpMultiselect
        zIndex="10"
        :showPlaceholderIcon="true"
        width="416"
        :isLoading="userRolesLoading"
        :showOptionsBorder="true"
        :showNoResults="true"
        v-model="user_role"
        label="name"
        :options="rolesOptions"
        :allowEmpty="true"
        :show-labels="false"
        :title="$t('common.userRole')"
        :disabled="!rolesOptions.length"
        :noResultMessage="$t('common.noResults')"
        @input="changeValues"
      />
      <div class="roles-hint">
        <span><b>{{$t('common.notes.note')}}:</b> {{ $t('common.notes.rolesHint') }}</span>
      </div>

      <VpTreeselect
        class="top-16"
        zIndex="11"
        :showPlaceholderIcon="true"
        width="416"
        :showOptionsBorder="true"
        :showNoResults="true"
        v-model="sites"
        :options="sitesOptions"
        :allowEmpty="true"
        :show-labels="true"
        :isLoading="sitesLoading"
        :label="$t('common.site')"
        :disabled="!sitesOptions.length"
        :noResultMessage="$t('common.noResults')"
        @select="changeValues"
        @deselect="changeValues"
      />

      <div v-if="hasNotPermittedSited" class="roles-hint">
        <span>
          <b>{{ $t('common.notes.note') }}:</b> {{ $t('journeyBuilder.form.removingSitesIsNotAllowedMessage') }}</span
        >
      </div>

      <VpTreeselect
        class="top-16"
        zIndex="12"
        :showPlaceholderIcon="true"
        width="416"
        :showOptionsBorder="true"
        :showNoResults="true"
        v-model="user_types"
        :options="userTypesOptions"
        :allowEmpty="true"
        :show-labels="true"
        :isLoading="userTypesLoading"
        :label="$t('common.userType')"
        :disabled="!userTypesOptions.length"
        :noResultMessage="$t('common.noResults')"
        dropDownStyle="relative"
        @select="changeValues"
        @deselect="changeValues"
      />

      <div v-if="hasNotPermittedUserTypes" class="roles-hint">
        <span>
          <b>{{ $t('common.notes.note') }}:</b> {{ $t('customFields.form.notPermittedRemove') }}</span
        >
      </div>
    </div>
    <hr class="h-line action-h-line" />

    <div class="modal-actions-btns">
    <VpButton :text="$t('common.change')" :isLoading="submitted" @click="onSubmit" :disabled="
          !user_role ||
          !sites.length ||
          !user_types.length ||
          isLoaded ||
          submitted
        " />
      
      <VpButton :text="$t('common.cancel')" @click="$bvModal.hide('addUserPermissionsModal')" :isDanger="true" />
      
    </div>
  </div>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PassportAction",
  components: {},
  data() {
    return {
      user_id: null,
      entity_user_id: null,
      submitted: false,
      isLoaded: false,
      user_role: null,
      sites: [],
      user_types: [],
      rolesOptions: [],
      sitesOptions: [],
      userTypesOptions: [],
      sitesLoading: true,
      userTypesLoading: true,
      userRolesLoading: true,
      multipleSelected: false,
      hasNotPermittedSited: false,
      hasNotPermittedUserTypes: false,
      oldRole: null,
      isEntityOtpEnabled : 0,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("authfack", ["currentEntity"]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("addUserPermissionsModal");
    },
  },
  methods: {
    ...mapActions("users", [
      "updateUserResource",
      "fetchUserRoles",
      "fetchUserResources",
      "fetchSitesAndUserTypesWithPermissions",
    ]),
    ...mapActions("sites", ["fetchAllSites"]),
    ...mapActions("userType", ["fetchAllParentsUserType"]),
    changeValues() {
      this.isLoaded = false;
    },
    async onSubmit() {
      this.submitted = true;
      const { entity_user_id, user_id, user_role, sites, user_types, oldRole } =
        this;
      const data = [
        {
          entityUserId: entity_user_id,
          userId: user_id,
          roleId: user_role.id,
          siteIds: sites,
          userTypeIds: user_types,
          type: "single",
        },
      ];

      this.updateUserResource(data).then(() => {
        this.$bvModal.hide("addUserPermissionsModal");
        this.$emit("changeUserStatusOrDeleted");

        setTimeout(() => {
          this.$socket.emit("pingUpdateUserRole", {
            // type : 'update_permissions',
            entity: this.currentEntity.id,
            user_id: user_id,
            role_id: user_role.id,
            newRole: user_role,
            oldRole: oldRole,
          });
        }, 500);

        if(this.isEntityOtpEnabled && this.user_role.id != this.oldRole.id){
          setTimeout(() => {
            this.$socket.emit('pingUpdateCompanyOtpAndRoles',{entity_id: this.currentEntity.id , isUserRoleChanged: true })
          },1000)
        }
      });
    },
  },
  async beforeMount() {
    console.log("this.getModalInfo", this.getModalInfo);
    this.user_id = this.getModalInfo.current_entity.user_id;
    this.entity_user_id = this.getModalInfo.current_entity.id;
    this.user_role = this.getModalInfo.current_entity.role;
    this.oldRole = this.getModalInfo.current_entity.role;
    
    await this.fetchSitesAndUserTypesWithPermissions({
      entityUserId: this.getModalInfo.current_entity.id,
    }).then((data) => {
      // console.log('data', data);
      this.sitesOptions = data.sites;
      data.sites.map((site) => {
        if (site.isDisabled) this.hasNotPermittedSited = true;
      });
      data.userTypes.map((type) => {
        if (type.isDisabled) {
          this.hasNotPermittedUserTypes = true;
        } else {
          if (type.children && type.children.length > 0) {
            type.children.map((child) => {
              if (child.isDisabled) this.hasNotPermittedUserTypes = true;
            });
          }
        }
      });
      this.userTypesOptions = data.userTypes;
      this.sitesLoading = false;
      this.userTypesLoading = false;
    });

    await this.fetchUserRoles().then((data) => {
      this.rolesOptions = data.data;
      this.userRolesLoading = false;
    });

    this.currentEntity.setting.map((row) => {
      if(row.name == "force_otp"){
        this.isEntityOtpEnabled = row.pivot.value;
      }
    });

    // await this.fetchAllSites().then((data)=>{
    //   this.sitesOptions = data.data;
    //   this.sitesLoading = false;
    // });

    // await this.fetchAllParentsUserType().then((data)=>{
    //   this.userTypesOptions = data.data;
    //   this.userTypesLoading = false;
    // });

    this.fetchUserResources({
      entityUserId: this.getModalInfo.current_entity.id,
    }).then((data) => {
      // console.log('data', data.data);
      this.sites = data.sites.map(function (site) {
        return site.id;
      });
      this.user_types = data.userTypes.map(function (userType) {
        return userType.id;
      });
    });

    // let user_resource = this.getModalInfo.current_entity.user_resource;

    // if(user_resource.length){
    //   for(let i = 0; i < user_resource .length;i++){
    //     if(user_resource[i].type == "site"){
    //       this.sites.push(user_resource[i].value);
    //     }else if(user_resource[i].type == "user_type"){
    //       this.user_types.push(user_resource[i].value);
    //     }
    //   }
    // }

    this.isLoaded = true;
  },
};
</script>
  
<style lang="scss" scoped>
.wrapper {
  .content {
    // padding: 0 10px;
    width: 416px;
    margin: auto;
  }
  .tilt{
    color: #000000!important;
  }
  .input-label {
    font-weight: normal;
    font-size: 14px;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 30px;
  }

  .row-group {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .input-h-line {
    margin: 24px 0 24px 0;
  }
  .action-h-line {
    margin: 40px 0 24px 0;
  }

  .err-wrapper {
    margin-top: 0;
    padding-inline-start: 19px;
  }

  .cancel-btn {
    margin-inline-end: 30px;
  }
}
</style>
  <style lang="scss">
.custom-margin {
  margin-bottom: 150px;
}
div#addUserPermissionsModal {
  .vue-treeselect__multi-value-label div {
    max-width: 306px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
div#addUserPermissionsModal___BV_modal_content_ {
  margin-top: 50px;
  margin-bottom: 50px;
  border-radius: 26px;
  width: 500px !important;
  div#addUserPermissionsModal___BV_modal_body_ {
    // .m-d-gruop > .form-control ~ label,.m-d-gruopp > .form-control ~ label{
    //   bottom: 36px!important;
    // }
    .vue-treeselect__option--disabled{
      opacity: 1!important;
      .vue-treeselect__label-container{
        opacity: 0.4!important;
        cursor: not-allowed;
      }
    }
    .error-value {
      font-weight: 600;
      line-height: 19px;
      font-size: 14px;
    }
    .title{
      color: #000000!important;
      text-align: center;
      font-size: 17px;
      font-weight: 700;
      line-height: 20.4px;
    }
    button.submit-btn.btn.btn-primary:disabled{
      opacity: 0.4!important;
    }

    .custom-multi-select {
      position: relative;
    }

    .content ul {
      margin-inline-start: 0px !important;
    }
  }
  .wizard-spinner {
    position: absolute !important;
    top: 26% !important;
    inset-inline-end: 2% !important;
    inset-inline-start: 90% !important;
  }
  .roles-hint {
    width: 377px;
    margin-inline-start: 20px;
    margin-top: 8px;
    margin-bottom: 16px;
    color: #939393;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0.25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
  }
}

.top-16 {
  margin-top: 16px !important;
}
</style>